import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/auto-send')({
    component: AutoSendRedirect,
});

// Auto send moved into the consolidated Scheduling page.
function AutoSendRedirect() {
    return <Navigate to="/settings/outreach-automation" replace={true} />;
}
